module.exports = __webpack_public_path__ + "static/img/6.56f03d6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/8/eng/6.png
// module id = wiXm
// module chunks = 0